// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","Title":"Title-3npcr8k4zdpbbjjdgv1vy2971avxcf93ca5cgc3phs7n3h287zqmhv1nte7x2g8epcjp43t9bn1nhzpras1vr79g5x67vw3y7pfymtb","loading":"loading-366vrup1c3qazy8tqdt7n3v9t6wyc3ue433ttac6pbvv7y7se765r59x1yrhvnvmaq13gxttakyw7m8wz3may1x6cwda16v7h7ywpud","pulse":"pulse-2ehk74yhr9man9ntj3cz2mj3dqwdr3pdsk92ahfpaqrud6gaujqvz7evp9xshc6cuj48hsk9yagbg6yb8h5b6ngehqzebn1ftbddmmu"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/Layout/components/Title/Title.module.scss
// module id = 1117
// module chunks = 0